import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { border, color, margin, pad, styles, table1 } from "./styles/pdf2Style";
import { t4Data, t4Headers, table1Data } from "./datas";
import getColumnWidth from "../utils/getColoumnWidth";

const Page4 = ({ TERMS, notes }) => {
  const T4ColumnWidths = [10, 30, 60];
  let sno = 1;

  return (
    <>
      <View style={{ marginTop: 10 }} break>
        {notes?.length > 0 && (
          <>
            <Text
              style={{
                fontSize: 12,
                fontFamily: "Helvetica-Bold",
                marginVertical: 20,
              }}
            >
              Note:-
            </Text>
            {notes?.map((item, index) => {
              if (item?.status === "Active") {
                return (
                  <Text key={index} style={{ marginBottom: 10 }}>
                    {index + 1}. <Text>{item?.description}</Text>
                  </Text>
                );
              } else {
                return null;
              }
            })}
          </>
        )}
      </View>
      <View style={styles.content}>
        {TERMS?.length > 0 && (
          <>
            {/* Table 3 */}
            <Text style={[styles.bold, margin.my10]}>
              Table 2: TERMS & CONDITIONS:
            </Text>

            {/* <View style={[color.bgBlack, styles.textCenter, pad.a5]}>
                      <Text style={[color.textWhite, styles.bold]}>TERMS & CONDITIONS</Text>
                    </View> */}
            <View>
              <View
                style={[
                  table1.table,
                  color.bgGray,
                  styles.bold,
                  { borderLeft: 1 },
                ]}
              >
                {t4Headers?.map((heading, i) => {
                  return (
                    <View
                      key={heading}
                      style={[
                        table1.cell,
                        color.bgBlack,
                        {
                          width: T4ColumnWidths[i] + "%",
                        },
                      ]}
                    >
                      <Text
                        style={[
                          styles.wrap,
                          styles.textCenter,
                          color.textWhite,
                        ]}
                      >
                        {heading}
                      </Text>
                    </View>
                  );
                })}
              </View>
              <View>
                {TERMS?.map((data, i) => {
                  if (data?.status === "Active") {
                    return (
                      <View style={[table1.table]} key={i}>
                        <View
                          key={0}
                          style={[
                            table1.cell,
                            pad.y5,
                            { width: T4ColumnWidths[0] + "%", borderLeft: 1 },
                          ]}
                        >
                          <Text style={[styles.wrap, styles.textCenter]} break>
                            {sno++}
                          </Text>
                        </View>
                        <View
                          key={1}
                          style={[
                            table1.cell,
                            ,
                            pad.y5,
                            { width: T4ColumnWidths[1] + "%" },
                          ]}
                        >
                          <Text style={[styles.wrap, styles.textCenter1]} break>
                            {data?.particulars}
                          </Text>
                        </View>
                        <View
                          key={1}
                          style={[
                            table1.cell,
                            pad.y5,
                            { width: T4ColumnWidths[2] + "%" },
                          ]}
                        >
                          <Text style={[styles.wrap, styles.textCenter1]} break>
                            {data?.remark}
                          </Text>
                        </View>
                      </View>
                    );
                  } else {
                    return null;
                  }
                })}
              </View>
            </View>
          </>
        )}
        <View break>
          <Text style={[margin.mt10]}>
            We trust that the proposed Quotation will be meeting your
            expectations.
          </Text>
          <Text style={[margin.my10]}>
            Thanking you & assuring you of our best services at all times.
          </Text>
          <Text style={[margin.mb10]}>Yours Sincerely,</Text>
          <Text style={[margin.my10, styles.bold]}>With Regards,</Text>
          <Text style={[styles.bold]}>Vinod D’cunha</Text>
          <Text style={[margin.mb10, styles.bold]}>Chief Operations Manager</Text>
        </View>
      </View>
    </>
  );
};

export default Page4;
